import { render, staticRenderFns } from "./BarraSalvarCancelar.vue?vue&type=template&id=d4d61a4e&scoped=true&"
import script from "./BarraSalvarCancelar.vue?vue&type=script&lang=js&"
export * from "./BarraSalvarCancelar.vue?vue&type=script&lang=js&"
import style0 from "./BarraSalvarCancelar.vue?vue&type=style&index=0&id=d4d61a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d61a4e",
  null
  
)

export default component.exports